import { MediaGatewayClient } from "@bloomberg/intercom";

const mediaGatewayClient = MediaGatewayClient.init({
    host: "host",
    username: "username",
    password: "password",
});

export { mediaGatewayClient };
